module.exports = __webpack_public_path__ + "img/carnego-icon.eb087b2e.png";